import React, { useState } from "react";
import FragmentTitles from './FragmentTitles';
import FragmentsViewer from './FragmentsViewer';
import Dropdown from "../../common/Dropdown";
import cx from "classnames";
import { makeRequest } from "../../../utils/request";

const Fragment = (fragmentData) => {
  const [data, setData] = useState(fragmentData);
  const [loadingPmbok, setLoadingPmbok] = useState(false);
  const showModal = async (item, selectedItem) => {
    const fragmentsVS = item && item.link && item.link.trim().split(":")[1] || "";
    const validItem = (selectedItem !== item.label) || false;
    const bookname = item.book;
    setSelectedLabel(item.label);
    if (fragmentsVS) {
      setLoadingPmbok(true);
      const dropdownSelectData = await makeRequest(
        "get",
        `/api/pmbok/${bookname}/fragments/${fragmentsVS}`
      );
      setLoadingPmbok(false);
      if (dropdownSelectData) {
        dropdownSelectData.attributionSources = fragmentData.data.attributionSources || []
        setData(dropdownSelectData)
      }
    }
  }
  const updatedFragmentData = data.data || data;
  const initialValue = updatedFragmentData.attributionSources.filter(attr => attr.book === fragmentData.data[0].book);
  const [selectedLabel, setSelectedLabel] = useState(initialValue[0].label);
  const findSelectIndex = () => {
    const selectedBook = updatedFragmentData.attributionSources[0].book || ''
    let updatedSource = updatedFragmentData.attributionSources || {}
    for (let e = 0; e < updatedSource.length; e++) {
      if (selectedBook === updatedSource[e].book) {
        updatedFragmentData.attributionSources[0].label = updatedSource[e].label;
      }
    }
  }
  const FragmentSources = () => {
    return <FragmentsViewer fragmentData={updatedFragmentData} />
  }
  const FragmentHeader = () => {
    return updatedFragmentData.attributionSources.length > 1 && (
      <div className="mb-2 pb-2 text-sm px-3 mt-2 sm:mt-0 font-semibold content-styling mb-6 pb-6 border-b-2 border-fuchsia-600 text-center" >
        Current source:
        <span className="rounded ml-1 py-1 px-1 border-gray-400" style={{ border: "gray solid 1px" }}>
          <Dropdown
            id="login_widget"
            items={updatedFragmentData.attributionSources}
            buttonLabel={
              <span className="text-lg text-black no-underline font-medium mr-1">
                <span className={cx("text-sm pl-2 mt-2 sm:mt-0", {
                  "cursor-pointer text-blue-700 underline": "",
                })}> {findSelectIndex()}{selectedLabel}
                  <i className="fas fa-chevron-down align-middle ml-1 ml-3"></i>
                </span>
              </span>
            }
            onClickItem={item => showModal(item, updatedFragmentData.attributionSources[0].label)}
            itemsStyles="border border-gray-400 agrandir text-xs font-thin mt-1 w-full text-left"
          />
        </span>
      </div>)
  }
  const FragmentAttribution = () => {
    return (
      <div className="select-none" style={{ height: "85%" }} onContextMenu={(e) => e.preventDefault()}>
        <div>
          {FragmentTitles[updatedFragmentData[0]?.book]}
        </div>
        <div
          className={cx("overflow-y-auto pr-6", { "mb-4": updatedFragmentData.length > 1 })}
          style={{
            height: (updatedFragmentData.attributionSources.length > 1 ? (updatedFragmentData.length > 1 ?
              `calc(100vh - .8rem)` : `calc(100vh - 13.8rem)`) :
              (updatedFragmentData.attributionSources.length === 1 ? (updatedFragmentData.length === 1 ?
                `calc(100vh - 9.4rem)` : `calc(100vh - 10.4rem)`) : null) ||
              `calc(100vh - 12.5rem)`)
          }}>
          <FragmentSources />
        </div>
      </div>
    )
  }
  return (
    <div className="h-full">
      <FragmentHeader />
      {loadingPmbok ? (<div className="h-64 my-10 mt-12" style={{ height: `calc(100vh - 14rem)` }}><div className="flex justify-center" ><i className="fas fa-spinner fa-spin" /></div></div>) : <FragmentAttribution />}
    </div>
  );
}

export default Fragment;